'use strict';/* global define */define('util/trigger-form-validation-and-submit',['require','exports','module','angular'],function(require,exports,module){'use strict';var ng=require('angular');/**
   * Workaround to trigger the default browser validation
   * when listening for submit event from the parent scope
   *
   * Should be executed in the link function of the directive containing the form
   */function triggerFormValidationAndSubmit(formElement){var btn=ng.element('<button></button>');formElement.append(btn);btn[0].click();btn.remove();}module.exports=triggerFormValidationAndSubmit;});
